/**
 * Password Strength Meter
 * Real-time password strength indicator
 * 
 * @since 3.7.0
 */

(function($) {
    'use strict';

    /**
     * Calculate password strength
     */
    function calculatePasswordStrength(password) {
        let strength = 0;
        
        if (password.length === 0) {
            return { score: 0, text: '', class: '' };
        }

        // Length check
        if (password.length >= 8) strength += 1;
        if (password.length >= 12) strength += 1;
        
        // Contains lowercase
        if (/[a-z]/.test(password)) strength += 1;
        
        // Contains uppercase
        if (/[A-Z]/.test(password)) strength += 1;
        
        // Contains numbers
        if (/\d/.test(password)) strength += 1;
        
        // Contains special characters
        if (/[^a-zA-Z0-9]/.test(password)) strength += 1;

        // Determine strength level
        if (strength <= 2) {
            return { score: 1, text: 'Weak', class: 'weak' };
        } else if (strength <= 4) {
            return { score: 2, text: 'Medium', class: 'medium' };
        } else {
            return { score: 3, text: 'Strong', class: 'strong' };
        }
    }

    /**
     * Create strength meter HTML
     */
    function createStrengthMeter() {
        return `
            <div class="password-strength-meter">
                <div class="strength-bar">
                    <div class="strength-bar-fill"></div>
                </div>
                <span class="strength-text"></span>
            </div>
        `;
    }

    /**
     * Update strength meter
     */
    function updateStrengthMeter($field, password) {
        const $meter = $field.siblings('.password-strength-meter');
        
        if ($meter.length === 0) return;

        const strength = calculatePasswordStrength(password);
        const $bar = $meter.find('.strength-bar-fill');
        const $text = $meter.find('.strength-text');

        // Update bar
        $bar.removeClass('weak medium strong').addClass(strength.class);
        
        // Update text
        $text.removeClass('weak medium strong').addClass(strength.class);
        $text.text(strength.text);

        // Update field class
        $field.removeClass('password-weak password-medium password-strong');
        if (strength.score > 0) {
            $field.addClass('password-' + strength.class);
        }
    }

    /**
     * Initialize password strength meter
     */
    function initPasswordStrength() {
        // Find password fields with strength meter class
        const $passwordFields = $('.simpleform-password-strength, input[name="password"]').filter(function() {
            // Only in registration forms (has confirm_password)
            return $(this).closest('form').find('input[name="confirm_password"]').length > 0;
        });

        $passwordFields.each(function() {
            const $field = $(this);
            
            // Skip if already initialized
            if ($field.siblings('.password-strength-meter').length > 0) {
                return;
            }

            // Add strength meter
            $field.after(createStrengthMeter());

            // Listen for input changes
            $field.on('input', function() {
                const password = $(this).val();
                updateStrengthMeter($field, password);
            });

            // Initial check if field has value
            if ($field.val()) {
                updateStrengthMeter($field, $field.val());
            }
        });
    }

    /**
     * Password visibility toggle
     */
    function initPasswordToggle() {
        const $passwordFields = $('input[type="password"]').filter(function() {
            return $(this).attr('name') === 'password' || $(this).attr('name') === 'confirm_password';
        });

        $passwordFields.each(function() {
            const $field = $(this);
            
            // Skip if already has toggle
            if ($field.siblings('.password-toggle').length > 0) {
                return;
            }

            // Wrap field if not already wrapped
            if (!$field.parent().hasClass('password-field-wrapper')) {
                $field.wrap('<div class="password-field-wrapper"></div>');
            }

            // Add toggle button
            const $toggle = $('<button type="button" class="password-toggle" aria-label="Toggle password visibility"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg></button>');
            
            $field.after($toggle);

            // Toggle functionality
            $toggle.on('click', function(e) {
                e.preventDefault();
                
                if ($field.attr('type') === 'password') {
                    $field.attr('type', 'text');
                    $toggle.addClass('visible');
                } else {
                    $field.attr('type', 'password');
                    $toggle.removeClass('visible');
                }
            });
        });
    }

    /**
     * Password match validation
     */
    function initPasswordMatch() {
        const $confirmFields = $('input[name="confirm_password"]');

        $confirmFields.each(function() {
            const $confirmField = $(this);
            const $form = $confirmField.closest('form');
            const $passwordField = $form.find('input[name="password"]');

            if ($passwordField.length === 0) return;

            // Check match on input
            $confirmField.on('input blur', function() {
                const password = $passwordField.val();
                const confirm = $confirmField.val();

                $confirmField.removeClass('password-match password-mismatch');

                if (confirm.length > 0) {
                    if (password === confirm) {
                        $confirmField.addClass('password-match');
                    } else {
                        $confirmField.addClass('password-mismatch');
                    }
                }
            });

            // Also check when password field changes
            $passwordField.on('input', function() {
                const confirm = $confirmField.val();
                if (confirm.length > 0) {
                    $confirmField.trigger('input');
                }
            });
        });
    }

    // Initialize on document ready
    $(document).ready(function() {
        initPasswordStrength();
        initPasswordToggle();
        initPasswordMatch();
    });

    // Re-initialize when new forms are loaded dynamically
    $(document).on('simpleform_loaded', function() {
        initPasswordStrength();
        initPasswordToggle();
        initPasswordMatch();
    });

})(jQuery);
